var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',[_vm._v("Сообщение с контактами для обращения")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }